import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EN_TRANSLATION from '../../translations/en.json';

export default function initI18N() {
  return i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: EN_TRANSLATION,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
}
